module.exports = __webpack_public_path__ + "static/media/nextjs.80cf8e4b.svg";